import * as React from 'react'

import { Carat, RotateClockwise } from '@syconium/little-miss-figgy'

import { BackButton, FormHeaderRow, FormTitle } from './styles'

export type FormHeaderProps = {
  /** The editor's name, e.g. "Add Text". */
  title: string
  /** Leaves the editor without saving. Where that lands is the flow's business. */
  onBack(): void
  /** The back control's accessible name — it draws as a bare chevron. */
  backLabel: string
}

/**
 * The line an editor opens with on desktop: the back control, then the editor's name.
 */
export const FormHeader: React.FC<FormHeaderProps> = ({ title, onBack, backLabel }) => (
  <FormHeaderRow>
    <BackButton
      type='button'
      aria-label={backLabel}
      borderless
      variant='ghost'
      size='small'
      onClick={onBack}
    >
      <Carat rotateClockwise={RotateClockwise.Half} height='16px' width='16px' strokeWidth='1.1' />
    </BackButton>

    {/* The modal's h1 already carries this title for assistive tech. */}
    <FormTitle aria-hidden>{title}</FormTitle>
  </FormHeaderRow>
)
